import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { api } from "../../lib/api";
import { Reveal, SectionHeading } from "../Reveal";

export function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/content/faqs").then((r) => setFaqs(r.data || [])).catch(() => {});
  }, []);

  const filtered = faqs.filter(
    (f) =>
      f.question.toLowerCase().includes(query.toLowerCase()) ||
      f.answer.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          chapter={["07", "Questions"]}
          title={
            <>
              Everything you're{" "}
              <em className="font-editorial font-medium italic text-gold-dark">wondering.</em>
            </>
          }
        />

        <Reveal delay={0.1}>
          <div className="relative mx-auto mt-10 max-w-md">
            <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input
              data-testid="faq-search-input"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search a question…"
              className="h-12 w-full rounded-full border border-input bg-bone pl-11 pr-4 text-sm outline-none transition-[border-color,box-shadow] duration-200 placeholder:text-muted-foreground/60 focus:border-gold focus:ring-2 focus:ring-gold/25"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
            {filtered.map((f, i) => (
              <AccordionItem
                key={f.id || f.question}
                value={`faq-${i}`}
                className="border-b border-border"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="gap-4 py-6 text-left hover:no-underline [&[data-state=open]>span.qnum]:text-gold-dark">
                  <span className="qnum mr-1 font-mono text-xs font-semibold text-forest/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-base font-bold text-forest-deep sm:text-lg">
                    {f.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-9 pr-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          {filtered.length === 0 && (
            <p className="mt-10 text-center text-sm text-muted-foreground" data-testid="faq-empty">
              No questions match “{query}”.
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
